import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[focus]'
})
export class FocusDirective {
  @Input()
  focus: boolean;

  constructor(private element: ElementRef) {

  }
  protected ngOnChanges() {
    this.element.nativeElement.focus();
  }

}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/directives/focus.directive.ts